import { render, staticRenderFns } from "./ObjectsLibrary.vue?vue&type=template&id=8895bc26&"
import script from "./ObjectsLibrary.vue?vue&type=script&lang=js&"
export * from "./ObjectsLibrary.vue?vue&type=script&lang=js&"
import style0 from "./ObjectsLibrary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports